const main = 'dispatching'

const relativeRoutes = {
  relativePage: `${main}/*`,
  relativeList: `${main}`,
  relativeListWithTab: 'tab-:activeTab',
}

const routes = {
  List: `/${main}`,
  ListWithTab: `/${main}/${relativeRoutes.relativeListWithTab}`,
}

const DispatchingRoutes = { ...relativeRoutes, ...routes }

export default DispatchingRoutes
